// Discards the wrapped Trans node entirely
export function HiddenTransNode(): null {
  return null
}
